export default "__VITE_ASSET__CSM_4XYL__"